import { render, staticRenderFns } from "./UserPayment.vue?vue&type=template&id=150440b3&scoped=true&"
import script from "./UserPayment.vue?vue&type=script&lang=js&"
export * from "./UserPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150440b3",
  null
  
)

export default component.exports